module.exports = __webpack_public_path__ + "media/images/pic/hero/courses/school/youth-027dd649bb2b6b258de13f6432d8dc51.jpeg";